import { BaseService } from 'core/services';
import { SellerOrganizationInfoRouteService } from 'common/data';

class SellerOrganizationInfoService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new SellerOrganizationInfoRouteService());
	}
}

export default SellerOrganizationInfoService;
